import { Alert, Group, Stack, Text } from "@mantine/core";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { StoredTemplateText } from "./StoredTemplateText";

// Плашка «сохранённый шаблон больше не проходит проверку»: причина с
// сервера и пояснение, какой шаблон действует вместо него. Сохранённое
// значение показывается, только если оно передано: на repo-уровне
// строка «Текущий override» уже выводит его, поэтому там `storedTemplate`
// равен `null`.
export function StoredTemplateInvalidAlert({
  storedTemplate,
  reason,
  fallbackNote,
}: {
  readonly storedTemplate: string | null;
  readonly reason: string;
  readonly fallbackNote: string;
}): ReactElement {
  const { t } = useTranslation();
  return (
    <Alert color="orange" title={t("branchNameTemplate.invalidStored.title")}>
      <Stack gap={4}>
        {storedTemplate !== null ? (
          <Group gap="xs">
            <Text size="sm" fw={600}>
              {t("branchNameTemplate.invalidStored.storedLabel")}
            </Text>
            <StoredTemplateText value={storedTemplate} />
          </Group>
        ) : null}
        <Text size="sm">
          {t("branchNameTemplate.invalidStored.reason", { reason })}
        </Text>
        <Text size="sm">{fallbackNote}</Text>
      </Stack>
    </Alert>
  );
}
